<template>
    <div class="fm-container">
        <Backer class="hidden-print" v-if="showbacker != false" />
        <div style="margin-bottom: 10px; width: 100%; text-align: center;">
            <b-form @submit="fetch_init" style="display: inline-block;" autocomplete="off">
                <b-form-input v-model="invoice.invoice_id" size="md" placeholder="INVOICE #" style="width: 200px; display: inline;" autocomplete="off"></b-form-input>
                <b-button type="submit" size="md" variant="success">Submit</b-button>
            </b-form>
        </div>
        <div v-if="(invoice.items || []).length > 0">
            <div>
                <b-alert show variant="success" style="padding:10px; margin-top: 10px; margin-bottom: 10px; font-size: 17px;">


                    <div style="width: 100%;">
                        <div style="width: 48%; text-align: left; display:inline-block; vertical-align: top;">
                            <b>INVOICE # {{ invoice.invoice_id }}</b>
                        </div>
                        <div style="width: 48%; text-align: right; display:inline-block; vertical-align: top;">
                            <span v-if="edit == false">
                                <b-button size="sm" variant="dark" @click="edit=true">EDIT</b-button>
                            </span>
                            <span v-else>
                                <b-button size="sm" variant="primary" @click="updateInvoice">SAVE</b-button>
                            </span>
                        </div>
                    </div>
                </b-alert>
            </div>

            <!-- <p>{{ invoice }}</p> -->

            <b-overlay :show="invoice_being_loaded" rounded="sm">
                <div style="margin-top: 10px;">
                    <!--invoice information-->
                    <b-card>
                        <!-- <div style="font-size: 20px;">Invoice Information</div> -->
                        <div>
                            <span style="display: inline-block; margin: 10px; width: auto;">
                                <b-card-text>
                                    <span>Date:</span>
                                    <span> {{ invoice.ts }}  </span>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; margin: 10px; width: auto;">
                                <b-card-text>
                                    <span>User:</span>
                                    <span> {{ (invoice.username || userDetails.username ) }}  </span>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block; margin: 10px;">
                                <b-card-text>
                                    <span>Location:</span>

                                    <span v-if="userDetails.userrole == 'admin'">
                                        <span style="display: inline-block; margin: 5px;">
                                            {{ locationsdict[invoice.location_id] }}
                                            /
                                            {{ sublocationsdict[invoice.sublocation_id] }}

                                        </span>
                                    </span>
                                    <span v-else>
                                        <span style="display: inline-block; margin: 5px;">
                                            {{ locationsdict[invoice.location_id] }} 
                                            /
                                            {{ sublocationsdict[invoice.sublocation_id] }}
                                        </span>
                                    </span>
                                </b-card-text>
                            </span>

                            <span style="display: inline-block;" v-if="invoice.sublocation_id != null">
                                <span v-show="invoice.sublocation_id != null" style="display: inline-block;  width: auto; background: #efefef; padding: 10px; border: 1px dashed black; ">
                                    <b-card-text>
                                        <span> Grand Total:</span>
                                        <span> $ {{ (getGrandTotal()).toFixed(2) }}  </span>
                                    </b-card-text>
                                </span>
                            </span>

                        </div>
                    </b-card>
                </div>

                <div style="margin-top: 10px;">
                    <div v-if="invoice.sublocation_id != null">
                        <!--customer information-->
                        <b-card style="margin-top: 10px;">
                            <div style="font-size: 20px;">Customer Information</div>
                            <div>
                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Firstname</div>
                                            <b-input size="sm" v-model="invoice.customer.firstname" placeholder="" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Firstname</b>: {{ invoice.customer.firstname }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Lastname</div>
                                            <b-input size="sm" v-model="invoice.customer.lastname" placeholder="" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Lastname</b>: {{ invoice.customer.lastname }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Email</div>
                                            <b-input size="sm" type="email" v-model="invoice.customer.email" placeholder="" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Email</b>: {{ invoice.customer.email }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Phone</div>
                                            <b-input size="sm" v-model="invoice.customer.phone" placeholder="" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Phone</b>: {{ invoice.customer.phone }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Phone 2</div>
                                            <b-input size="sm" v-model="invoice.customer.phone_2" placeholder="" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Phone 2</b>: {{ invoice.customer.phone_2 }}</div>
                                        </span>
                                    </b-card-text>
                                </span>
                            </div>

                            <div>
                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Address</div>
                                            <b-input size="sm" v-model="invoice.customer.address" placeholder="Address" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Address</b>: {{ invoice.customer.address }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Apt # </div>
                                            <b-input size="sm" v-model="invoice.customer.apt" placeholder="" style="width: 80px;" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Apt</b>: {{ invoice.customer.apt }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Floor</div>
                                            <b-input size="sm" v-model="invoice.customer.floor" placeholder="" style="width: 100px;" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Floor</b>: {{ invoice.customer.floor }}</div>
                                        </span>
                                    </b-card-text>
                                </span>

                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">City</div>
                                            <b-input size="sm" v-model="invoice.customer.city" placeholder="" style="width: 100px;" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>City</b>: {{ invoice.customer.city }}</div>
                                        </span>
                                    </b-card-text>
                                </span>


                                <span style="display: inline-block; margin: 10px;">
                                    <b-card-text>
                                        <span v-if="edit == true">
                                            <div style="font-size: 13px;">Zipcode </div>
                                            <b-input size="sm" v-model="invoice.customer.zipcode" placeholder="" style="width: 100px;" autocomplete="off"></b-input>
                                        </span>
                                        <span v-else>
                                            <div><b>Zipcode</b>: {{ invoice.customer.zipcode }}</div>
                                        </span>
                                    </b-card-text>
                                </span>
                            </div>
                        </b-card>

                        <!--products-->
                        <b-card style="margin-top: 10px;">
                            <div style="font-size: 20px;">Products</div>
                            <div>
                                <b-alert show variant="primary" v-if="invoice.items.length <= 0">
                                    No products added.
                                </b-alert>

                                <table class="ipt" v-else>
                                    <thead>
                                        <tr style="background: #efefef;">
                                            <td class="ipt_tdhr">#</td>
                                            <td class="ipt_tdhr">ID</td>
                                            <td class="ipt_tdhr">Name</td>
                                            <td class="ipt_tdhr">SKU</td>
                                            <td class="ipt_tdhr">Vendor</td>
                                            <td class="ipt_tdhr">Unit Price ($)</td>
                                            <td class="ipt_tdhr">Quantity ($)</td>
                                            <td class="ipt_tdhr">Discount ($)</td>
                                            <td class="ipt_tdhr">Total ($)</td>
                                            <td class="ipt_tdhr">Order Type</td>
                                            <!-- <td class="ipt_tdhr">Pickup Date</td>
                                            <td class="ipt_tdhr">Delivery Date</td> -->
                                            <td class="ipt_tdhr hidden-print">Status</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="product, idx in invoice.items">
                                            <td class="ipt_tdr">  
                                                {{ idx + 1 }}
                                            </td>
                                            <td class="ipt_tdr">  
                                                {{ product.product_id }}
                                            </td>
                                            <td class="ipt_tdr">  
                                                <span style="font-weight: bold;">{{product.product_name.toUpperCase() }}</span>

                                                <span v-show="product.is_special == true" style="padding: 1px; background: orange; color: white; border-radius: 3px; margin-left: 5px;">
                                                special
                                                </span>

                                                <div v-show="product.children.length > 0" style="margin-bottom: 10px;">
                                                    <b-card-text>
                                                        
                                                        <div v-for="child, idxx in product.children" style="font-size: 10px !important; width: auto; background-color: #efefef; padding: 3px; margin: 6px;">
                                                            
                                                            <b>{{child.product_name}}</b> ({{ child.sku }}) X {{child.quantity}}

                                                        </div>
                                                    </b-card-text>
                                                </div>

                                            </td>
                                            <td class="ipt_tdr">
                                                {{ product.product_sku}}
                                            </td>
                                            <td class="ipt_tdr">
                                                {{ product.product_vendor}}
                                            </td>
                                            <td class="ipt_tdr">
                                                ${{ (product.selling_price * 100.0 / 100.0).toFixed(2) }}
                                            </td>
                                            <td class="ipt_tdr">
                                                <span style="width: 80px; display: inline-block;">
                                                   <!-- <b-input type="number" min="1" v-model="product.quantity" size="sm"></b-input> -->
                                                   <div><b>{{ product.quantity }}</b></div>
                                                </span>
                                            </td>
                                            <td class="ipt_tdr">
                                                <span style="width: 80px; display: inline-block;">
                                                    <!-- <b-input type="number" min="1" v-model="product.discount_offered" size="sm"></b-input> -->

                                                    <div><b>{{ (product.discount_offered.toFixed(2) || 'N/A' ) }}</b></div>
                                                </span>
                                            </td>
                                            <td class="ipt_tdr">
                                                <b>
                                                $ {{ getItemTotal(idx) }}
                                                </b>
                                            </td>

                                            <td class="ipt_tdr" style="padding: 10px;">
                                                <span v-if="edit == true">
                                                    <b-form-select
                                                        v-model="product.order_type"
                                                        :options="order_types"
                                                        size="sm"
                                                        variant="outline-primary"
                                                    ></b-form-select>
                                                </span>
                                                <span v-else>
                                                    <div style="padding: 3px; background: #efefef;">{{order_types.filter(function(d){return d.value == product.order_type})[0].text }}</div>
                                                </span>
                                            
                                                <div v-if="product.order_type == 'store_pickup'" style="background-color: #efefef; padding: 5px; margin-top: 10px;">
                                                    <div style="margin-top: 10px;">Pickup Date</div>

                                                    <span v-if="edit == true">
                                                        <b-form-datepicker 
                                                        reset-button
                                                        size="sm" placeholder="" v-model="product.pickup_date"  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US" :date-disabled-fn="dateDisabled"></b-form-datepicker>
                                                    </span>
                                                    <span v-else>
                                                        <div style="padding: 3px; background: #efefef;">{{product.pickup_date}}</div>
                                                    </span>
                                                </div>
                                                <div v-if="product.order_type == 'home_delivery'" style="background-color: #efefef; padding: 5px; margin-top: 10px;">
                                                    <div style="margin-top: 10px;">Delivery Date</div>
                                                    <span v-if="edit == true">
                                                        <b-form-datepicker 
                                                        reset-button
                                                        size="sm" placeholder="" v-model="product.delivery_date" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en-US" :date-disabled-fn="dateDisabled"></b-form-datepicker>
                                                    </span>
                                                    <span v-else>
                                                        <div style="padding: 3px; background: #efefef;">{{product.delivery_date}}</div>
                                                    </span>
                                                </div>
                                                <div v-if="product.order_type == 'customer_takes'" style="background-color: #efefef; padding: 5px; margin-top: 10px;">
                                                    <span v-if="edit == true">
                                                        <div style="margin-top: 10px;">Pick Source</div>
                                                        <b-form-select
                                                            v-model="product.source_sublocation_id"
                                                            :options="sublocations.filter(function(d){return d.location_id == invoice.location_id })"
                                                            value-field="value"
                                                            text-field="text"
                                                            size="sm"
                                                            variant="outline-primary"
                                                        ></b-form-select>
                                                    </span>
                                                    <span v-else>
                                                        <div style="padding: 3px; background: #efefef;">{{locationsdict[product.source_location_id]}} / {{sublocationsdict[product.source_sublocation_id]}}</div>
                                                    </span>
                                                </div>
                                            </td>

                                            <td class="ipt_tdr hidden-print">
                                                {{ invoice_item_statuses[product.status] }}
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </b-card>


                        <!--summary-->
                        <b-card v-show="invoice.items.length > 0" style="margin-top: 10px; margin-right: 10px; width: 47%; display: inline-block; vertical-align: top;">
                            <div style="font-size: 20px;">Summary</div>

                            <div style="width: auto; display: inline-block; margin: 10px;  vertical-align: top;">
                                <table style="margin: 5px;">
                                    <thead>
                                        <th style="background: #efefef; padding: 5px; font-size: 14px;">
                                           Misc. Charges
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="ipt_tdr">
                                                Delivery Fees ($)
                                            </td>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                <!-- <b-input required size="sm" autocomplete="off" type="number" min="0" v-model="invoice.delivery_charges" style="width: 80px;"></b-input> -->
                                                <div><b>{{ (invoice.delivery_charges.toFixed(2) || 0.0) }}</b></div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="ipt_tdr"  style="padding: 5px;">
                                                Total Warranty ($)
                                            </td>
                                            <td class="ipt_tdr"  style="padding: 5px;">
                                                <!-- <b-input required size="sm" autocomplete="off" type="number" min="0" v-model="invoice.warranty_charges" style="width: 80px;"></b-input> -->
                                                <div><b>{{ (invoice.warranty_charges.toFixed(2) || 0.0) }}</b></div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="ipt_tdr">
                                                Setup Fees ($)
                                            </td>
                                            <td class="ipt_tdr">
                                                <!-- <b-input required size="sm" autocomplete="off" type="number" min="0" v-model="invoice.setup_charges" style="width: 80px;"></b-input> -->
                                                <div><b>{{ (invoice.setup_charges.toFixed(2) || 0.0) }}</b></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div style="width: auto; display: inline-block; margin: 10px;  vertical-align: top;">
                                <table style="margin: 5px;">
                                    <thead>
                                        <th style="background: #efefef; padding: 5px; font-size: 14px;">
                                           Total Discounts
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                Discounts ($)
                                            </td>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                {{ (getTotalDiscount()).toFixed(2) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div style="width: auto; display: inline-block; margin: 10px;  vertical-align: top;">
                                <table style="width: auto; display: inline-block; margin: 10px;  vertical-align: top;">
                                    <thead>
                                        <th style="background: #efefef; padding: 5px;">
                                           Totals
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                <b>Order Total ($)</b>
                                            </td>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                {{ (getOrderTotal()).toFixed(2) }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                <b>Total Charges ($)</b>
                                            </td>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                {{ (getChargesTotal()).toFixed(2) }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                <b>Subtotal ($)</b>
                                            </td>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                + {{ (getSubTotal()).toFixed(2) }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                <b>Sales Tax ($)</b>
                                            </td>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                {{ (getSalesTax()).toFixed(2) }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="ipt_tdr" style="padding: 5px;">
                                                <b>Grand Total ($)</b>
                                            </td>
                                            <td class="ipt_tdr" style="background: yellow; padding: 5px;">
                                                {{  (getGrandTotal()).toFixed(2) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                            <!--submit-->
                            <!-- <div 
                                style="text-align: center; margin-botton: 20px; margin-top: 10px; padding: 10px;" 
                                class="hidden-print"
                                v-if="invoice.items.length > 0 && invoice.payment_methods.length > 0 && getGrandTotal() > 0"
                            >
                                <span v-if="block_post_invoice == false">
                                    <b-button size="md" variant="success" @click="submitInvoice">Submit</b-button>
                                </span>
                                <span v-else>
                                    <b-button size="md" variant="success">
                                        <b-spinner small variant="success"></b-spinner>
                                        Submit
                                    </b-button>
                                </span>
                            </div> -->
                        </b-card>


                        <!--payment details-->
                        <b-card v-show="invoice.items.length > 0" style="margin-top: 10px; margin-right: 10px; width: 50%; display: inline-block; vertical-align: top;">
                            <div style="font-size: 20px;">Payment Details</div>
                            <div v-for="payment_method, pmidx in invoice.payment_methods" style="width: auto; display: inline-block; margin: 10px; vertical-align: top; background: #efefef; padding: 10px;">

                                <span v-if="edit == true">
                                    <div style="margin-left: 95%; margin-bottom: 10px;" class="hidden-print">
                                        <b-badge size="sm" variant="danger" @click="removePaymentMethod(pmidx)" style="cursor: pointer;">X</b-badge>
                                    </div>
                                </span>
                                <table>
                                    <thead v-show="invoice.payment_methods[pmidx].value != null">
                                        <th style="background: black; color: white; padding: 5px; border: 1px solid black;">
                                           {{ invoice.payment_methods[pmidx].value  }}
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="ipt_tdr">
                                                Payment Method
                                            </td>
                                            <td class="ipt_tdr">
                                                <b-form-select
                                                    value-field="value"
                                                    text-field="text"
                                                    :options="payment_method_options"
                                                    v-model="invoice.payment_methods[pmidx].value"
                                                    size="sm"
                                                    :disabled="!edit"
                                                ></b-form-select>
                                            </td>
                                        </tr>
                                        <tr v-if="invoice.payment_methods[pmidx].value">
                                            <td class="ipt_tdr">
                                                Amount ($)
                                            </td>
                                            <td class="ipt_tdr">
                                                <span v-if="edit == true">
                                                    <b-input type="number" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].amount" style="width: 100px; display: absolute;"></b-input>
                                                </span>
                                                <span v-else>
                                                    <div><b>${{ (invoice.payment_methods[pmidx].amount.toFixed(2) || 0.0) }}</b></div>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr v-show="invoice.payment_methods[pmidx].value == 'finance'">
                                            <td class="ipt_tdr">
                                                Finance Company
                                            </td>
                                            <td class="ipt_tdr">
                                                <b-form-select
                                                    value-field="value"
                                                    text-field="text"
                                                    :options="finance_companies"
                                                    v-model="invoice.payment_methods[pmidx].finance_company"
                                                    size="sm"
                                                    :disabled="!edit"
                                                ></b-form-select>
                                            </td>
                                        </tr>

                                        <tr v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                            <td class="ipt_tdr">
                                                Lease ID
                                            </td>
                                            <td class="ipt_tdr">
                                                <span v-if="edit == true">
                                                    <b-input type="text" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].lease_id" style="width: 200px;"></b-input>
                                                </span>
                                                <span v-else>
                                                    <div><b>{{ invoice.payment_methods[pmidx].lease_id }}</b></div>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr v-if="invoice.payment_methods[pmidx].value == 'finance' && invoice.payment_methods[pmidx].finance_company != null && invoice.payment_methods[pmidx].finance_company != undefined ">
                                            <td class="ipt_tdr">
                                                Contact #
                                            </td>
                                            <td class="ipt_tdr">
                                               {{ finance_companies.filter(function(d){return d.value == invoice.payment_methods[pmidx].finance_company})[0].phone_number }}
                                            </td>
                                        </tr>

                                        <tr v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                            <td class="ipt_tdr">
                                                ACCT#/ETC.
                                            </td>
                                            <td class="ipt_tdr">
                                                <span v-if="edit == true">
                                                    <b-input type="text" size="sm" autocomplete="off" v-model="invoice.payment_methods[pmidx].misc_info" style="width: 200px;"></b-input>
                                                </span>
                                                <span v-else>
                                                    {{ invoice.payment_methods[pmidx].misc_info }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <span v-if="edit == true">
                                <div class="hidden-print">
                                    <b-button size="sm" variant="dark" @click="addPaymentMethod">Add Payment Method</b-button>
                                </div>
                            </span>
                        </b-card>                        
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>


<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    import moment from 'moment'

    export default {
        name: "ViewInvoice",
        props: ["showbacker"],
        components: {Backer,VueGoodTable,Multiselect},
        data: function(){
            let out = {
                edit: false,
                show_add_products: false,
                userDetails: {properties: {}},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict:  {},
                search_keyword: null,
                block_search: false,
                searched_products: [],
                searched_products_columns: [
                    {
                        label: "ID",
                        field: "id",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Name",
                        field: "product_name",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "SKU",
                        field: "sku",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Selling Price",
                        field: "selling_price",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Quantity",
                        field: "quantity",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Available",
                        field: "available",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Reserved",
                        field: "reserved",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                ],
                special_product: {},
                payment_method_options: [
                    {value: "cc", text: "Credit Card"},
                    {value: "cash", text: "Cash"},
                    {value: "finance", text: "Finance"},
                    {value: "layaway", text: "Lay Away"},
                ],
                finance_companies: [
                    {value: "SNAP FINANCE", text: "SNAP FINANCE", phone_number: "1-877-557-3769"},
                    {value: "U-OWN LEASING", text: "U-OWN LEASING", phone_number: "1-877-353-8696"},
                    {value: "PREFERRED LEASE", text: "PREFERRED LEASE", phone_number: "1-770-575-5980"},
                    {value: "ACIMA CREDIT", text: "ACIMA CREDIT", phone_number: "1-801-297-1926"},
                    {value: "KORNERSTONE CREDIT", text: "KORNERSTONE CREDIT", phone_number: "1-888-521-5111"},
                    {value: "SYNCHRONY", text: "SYNCHRONY", phone_number: "1-800-677-0718"},
                    {value: "EASY PAY FINANCE", text: "EASY PAY FINANCE", phone_number: "1-866-337-2537"},
                    {value: "GREAT AMERICAN FINANCE", text: "GREAT AMERICAN FINANCE", phone_number: "1-866-944-2326"},
                ],
                order_types: [
                    {"value": "customer_takes", "text": "Take It Home"},
                    {"value": "store_pickup", "text": "Store Pickup"},
                    {"value": "home_delivery", "text": "Home Delivery"},
                ],
                invoice_item_statuses: {
                    0: "PENDING",
                    1: "APPROVED",
                    2: "REJECTED",
                    3: "DISPATCHED",
                    4: "DELIVERED"
                },
                block_post_invoice: false,
                invoice_being_loaded: false,
            };

            out.invoice =  {
                ts: Requestor.moment(),
                invoice_id: null,
                username: null, 
                customer: {
                    firstname: null,
                    lastname: null,
                    email: null,
                    phone: null,
                    phone_2: null,
                    address: null,
                    floor: null,
                    apt: null,
                    city: null,
                    zipcode: null,
                },
                items: [],
                delivery_charges: 0,
                setup_charges: 0,
                warranty_charges: 0,
                payment_methods: [],
                location_id: null,
                sublocation_id: null,
            };
            return out;
        },
        methods: {
            resetInvoice: function(){
                this.invoice =  {
                    ts: Requestor.moment(),
                    invoice_id: null,
                    username: null, 
                    customer: {
                        firstname: null,
                        lastname: null,
                        email: null,
                        phone: null,
                        address: null,
                        zipcode: null,
                    },
                    items: [],
                    delivery_charges: 0,
                    setup_charges: 0,
                    warranty_charges: 0,
                    payment_methods: [],
                    location_id: null,
                    sublocation_id: null,
                };
            },
            updateInvoice: function(e) {
                if (e) {
                    e.preventDefault();
                }

                let invoice = this.invoice;
                invoice.warranty_charges = (+invoice.warranty_charges || 0.0);
                invoice.delivery_charges = (+invoice.delivery_charges || 0.0);
                invoice.setup_charges = (+invoice.setup_charges || 0.0);
                invoice.sales_tax = this.getSalesTax();

                //val # 1: confirm that user details are not empty
                let customer_information_validation = this.validate_customer_info(invoice.customer);
                if (customer_information_validation == false){
                    this.$bvToast.toast(
                        "Please fill out all the required fields for customer information.", 
                        {title: "Incomplete", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                //val # 2: confirm that products are not empty + product quanties are valid
                let products_validation = this.validate_products(invoice.items);
                if (products_validation == false){
                    this.$bvToast.toast(
                        "Please verify the products and their quantities.", 
                        {title: "Incomplete", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                //val # 3: confirm that the amounts specified in payment methods do add up the grand total.
                let payment_methods_validation = this.validate_payment_methods(invoice.payment_methods);
                if (payment_methods_validation == false){
                    this.$bvToast.toast(
                        "Please verify the total payments are equal to grand total.", 
                        {title: "Incomplete", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                invoice.payment_methods = invoice.payment_methods.map(function(d){
                    d.amount = (+d.amount || 0.0); return d;
                });

                let that = this;
                let path = "/api/sales/update_sale/"
                let data = invoice;
                console.log(data)

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        let invoice_id = response.data.result.invoice_id;
                        // if (invoice_id){
                        //     that.edit = false;
                        //     that.fetch_init();
                        // }
                        that.edit = false;
                        that.fetch_init();
                    }
                    that.block_post_invoice=false;
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred while updating. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.block_post_invoice=false;
                    that.edit = false;
                }
                this.block_post_invoice = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            getSubTotal: function(){
                let order_total = this.getOrderTotal();
                let total_charges = this.getChargesTotal();
                return (order_total + total_charges);
            },
            getItemTotal: function(idx){
                let item = this.invoice.items[idx];
                let sp = (+item.selling_price || 0.0);
                let qty = (+item.quantity || 1.0);
                let dsc = (+item.discount_offered || 0.0);
                return ( (sp*qty) - dsc ).toFixed(2);
            },
            getOrderTotal: function(){
                var k = 0.0;
                for (var i =0; i<this.invoice.items.length; i++){
                    let sp = (+this.invoice.items[i].selling_price || 0.0);
                    let qty = (+this.invoice.items[i].quantity || 1.0);
                    let dsc = (+this.invoice.items[i].discount_offered || 0.0);

                    k += ( (sp*qty) - dsc );
                }
                return k;

            },
            getChargesTotal: function(){
                let dlv = (+this.invoice.delivery_charges || 0.0);
                let stp = (+this.invoice.setup_charges || 0.0);
                let wtp = (+this.invoice.warranty_charges || 0.0);
                return (dlv + stp + wtp);
            },
            getSalesTax: function(){
                let total_charges = this.getChargesTotal();
                let order_total = this.getOrderTotal();
                let perc = 0.10;
                return (order_total + total_charges) * perc;
            },
            getTotalDiscount: function(){
                var k = 0.0;
                for (var i =0; i<this.invoice.items.length; i++){
                    let dsc = (+this.invoice.items[i].discount_offered || 0.0);
                    k += dsc;
                }
                return k;
            },
            getGrandTotal: function(){
                let order_total = this.getOrderTotal();
                let total_charges = this.getChargesTotal();
                let sales_tax = this.getSalesTax();
                return (order_total + total_charges + sales_tax) * 1.0;
            },

            onSearchedProductsColumnClick: function(params){
                let action = params.event.target.innerText;
                if (action === "Add") {
                    this.addRow(params.row);
                }
            },
            addPaymentMethod: function(e){
                if (e){
                    e.preventDefault();
                }

                let new_payment_method = {
                    value: null,
                    amount: 0.0,
                    properties: {}
                }
                this.invoice.payment_methods.push(new_payment_method);
            },
            addRow: function(product){
                let id = product.id;
                let exists = this.invoice.items.filter(function(d){
                    return d.id == id;
                });

                if (exists.length > 0){
                    this.$bvToast.toast(
                        "Product already exists in the list. Please increment its count.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                if (isNaN(parseFloat(product.quantity)) || product.quantity == null || isNaN(product.quantity)) {
                    this.$bvToast.toast(
                        "Cannot add a non-numeric product quantity to product list", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                let p = {
                    product_id: product.id,
                    product_name: product.product_name,
                    product_sku: product.sku,
                    vendor: null,
                    quantity: parseInt(product.quantity),
                    selling_price: parseFloat(product.selling_price),
                    discount_offered: 0.0,
                    children: product.children,
                    is_special: false,
                    order_type: null,
                    pickup_date: null,
                    delivery_date: null,
                }
                this.invoice.items.push(p);
                this.clearSearchedProducts();
                this.show_add_products = false;
            },
            clearSearchedProducts: function(e){
                if (e){
                    e.preventDefault();
                }
                this.searched_products = [];
                this.search_keyword = null;
            },
            addSpecialProduct: function(e){
                if (e){
                    e.preventDefault();
                }
                let special_product = this.special_product;
                let p = {
                    product_id: special_product.id,
                    product_name: special_product.product_name,
                    product_sku: special_product.sku,
                    vendor: special_product.vendor,
                    quantity: parseInt(special_product.quantity),
                    selling_price: parseFloat(special_product.selling_price),
                    discount_offered: 0.0,
                    children: [],
                    is_special: true,
                    order_type: null,
                    pickup_date: null,
                    delivery_date: null
                }
                this.invoice.items.push(p);
                this.special_product = {};
            },
            searchProducts: function(e){
                if (e){
                    e.preventDefault();
                }
                if (!this.search_keyword || this.search_keyword.length < 2){
                    this.$bvToast.toast(
                        "Please search with a more specific keyword", 
                        {title: "Incomplete Search", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                let that = this;
                let path = "/api/product/search_products_for_sales/"
                let data = {keyword: this.search_keyword}

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else{
                        console.log(response.data.result)
                        that.searched_products = response.data.result;
                        if (that.searched_products.length == 0){
                            that.$bvToast.toast(
                                "No products found matching keyword: '"+that.search_keyword+"'", 
                                {title: "No result", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                    that.block_search=false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.block_search=false;
                }
                this.block_search = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            removeItem: function(idx){
                this.invoice.items.splice(idx, 1);
            },
            removePaymentMethod: function(pmidx){
                this.invoice.payment_methods.splice(pmidx, 1);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, description: d.description}
                                });

                                if (that.userDetails){
                                    if (that.userDetails.properties){
                                        if (that.userDetails.properties.location_id){
                                            let location_id = that.userDetails.properties.location_id;

                                            that.locations = that.locations.filter(function(d){return d.value == location_id });
                                            that.invoice.location_id = location_id;
                                        }
                                    }
                                }

                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id, sublocation_type_id: d.sublocation_type_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                //after all is done, call fetch init.
                                //that.fetch_init();
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);    
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function(){
                if (!(this.invoice.invoice_id)){
                    console.log("nothing to call here..")
                    return
                }
                let that = this;
                let path = "/api/sales/get_invoice/"
                let data = {invoice_id: this.invoice.invoice_id};                

                let s = function(response){
                    if (response.data.result){
                        if (!response.data.result.invoice_id){
                            that.$bvToast.toast(
                                "Invoice not found.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            that.resetInvoice()
                            that.invoice.invoice_id = data.invoice_id;
                        }
                        else {
                            that.invoice = response.data.result;
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.resetInvoice()
                    }
                    that.invoice_being_loaded = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading invoice data.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.resetInvoice()
                    that.invoice_being_loaded = false;
                }
                that.invoice_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            onSublocationSelect: function(sublocation_id) {
                let ts = Requestor.moment();
                let sublocation = this.sublocations.filter(function(d){return d.id == sublocation_id});
                if (sublocation.length>0) {
                    let sublocation_name = sublocation[0].shortcut.replace(" - ", " ").split(" ").join("-");
                    this.location_id = sublocation[0].location_id;
                    this.sublocation_id = sublocation_id
                    this.invoice_id = sublocation_name+"-"+(parseInt(ts.valueOf()/1000));
                }
            },
            validate_customer_info: function(customer_information){
                let valid = true;
                if (!customer_information.firstname){
                    valid = false;
                }
                if (!customer_information.lastname){
                    valid = false;
                }
                if (!customer_information.email){
                    valid = false;
                }
                if (!customer_information.phone){
                    valid = false;
                }
                if (!customer_information.zipcode){
                    valid = false;
                }

                return valid;
            },
            validate_products: function(products){
                let valid = true;
                if (products.length <=0){
                    valid = false;
                }
                if (products.map(function(d){return (d.quantity || 0)}).indexOf(0) >= 0 ){
                    valid = false;
                }

                for (var i=0; i<products.length; i++){
                    let pickup_date = products[i].pickup_date;
                    let delivery_date = products[i].delivery_date;
                    let order_type = products[i].order_type;

                    if (!order_type){
                        valid = false;
                    }

                    if (order_type == "store_pickup"){
                        if (!pickup_date){
                            valid = false;
                        }
                        else {
                            if (moment(pickup_date) < moment()){
                                valid = false;
                                this.$bvToast.toast(
                                    "All pickup dates should be in future.", 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        }

                        products[i].delivery_date = null;
                    }

                    if (order_type == "home_delivery"){
                        if (!delivery_date){
                            valid = false;
                        }
                        else {
                            if (moment(delivery_date) < moment()){
                                valid = false;
                                this.$bvToast.toast(
                                    "All delivery dates should be in future.", 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        }
                        products[i].pickup_date = null;
                    }

                    if (order_type == "customer_takes"){
                        if (products[i].source_sublocation_id == null || products[i].source_sublocation_id == undefined){
                            valid = false;
                        }
                        products[i].pickup_date = null;
                        products[i].delivery_date = null;
                    }
                }

                return valid;
            },
            validate_payment_methods: function(payment_methods){
                let valid = true;
                var s = 0;
                var gt = parseFloat(this.getGrandTotal());
                for (var i=0; i<payment_methods.length; i++){
                    s += (parseFloat(payment_methods[i].amount) || 0.0);

                    if (payment_methods[i].value == "finance"){
                        if (!(payment_methods[i].lease_id)){
                            valid = false;
                        }
                        if (!(payment_methods[i].finance_company)){
                            valid = false;
                        }
                    }
                }
                s = parseFloat(s.toFixed(2));
                gt = parseFloat(gt.toFixed(2));
                if (s < gt){
                    valid = false
                }
                return valid
            },
            dateDisabled: function(ymd, date){
                return date <= moment()        
            }
        },
        created: function() {
            this.invoice.invoice_id = null
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();


                let hash = this.$route.hash;
                let params = this.$route.params;
                console.log(hash)
                console.log(params)
                if (hash){
                    let s1 = hash.split("?")
                    if (s1.length > 1){
                        let s2 = s1[1].split("=");
                        if (s2.length > 1){
                            let invoice_id = s2[1].replace("/", "").replace(" ", "");
                            if (invoice_id){
                                this.invoice.invoice_id = invoice_id
                                this.fetch_init()
                            }
                        }
                    }
                }
                else if (params.invoice_id){
                    this.invoice.invoice_id = this.$route.params.invoice_id;
                    
                    this.fetch_init();
                }
                
            }
        }
    }
</script>

<style scoped>

    .ipt_tdr {
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ViewInvoice.vue